// material-ui
// project import
import type { MainCardProps } from 'components/MainCard'

import { Box, useTheme } from '@mui/material'
import MainCard from 'components/MainCard'

// ==============================|| AUTHENTICATION - CARD WRAPPER ||============================== //

function AuthCard({ children, ...other }: MainCardProps) {
  const theme = useTheme()

  return (
    <MainCard
      sx={{
        maxWidth: { xs: 400, lg: 475 },
        margin: { xs: 2.5, md: 3 },
        '& > *': {
          flexGrow: 1,
          flexBasis: '50%',
        },
      }}
      content={false}
      {...other}
      border={false}
      boxShadow
      shadow={theme.customShadows.z1}
    >
      <Box sx={{ p: { xs: 2, sm: 3, md: 4, xl: 5 } }}>{children}</Box>
    </MainCard>
  )
}

export default AuthCard
